import {createContext, useState} from "react";

export const UserContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    let emptyUser = {
        id: "",
        username: "",
        password: "",
        fullName: "",
        email: "",
        enabled: true,
        type: null,
        description: ""
    }

    const [user, setUser] = useState(emptyUser);
    const [users, setUsers] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [userDialog, setUserDialog] = useState(false);

    const resetUser = () => {
        setUser(emptyUser);
    };

    // Make the context object:
    const userContext = {
        user,
        resetUser,
        setUser,
        users,
        setUsers,
        submitted,
        setSubmitted,
        userDialog,
        setUserDialog,
    };

    // pass the value in provider and return
    return <UserContext.Provider value={userContext}>{children}</UserContext.Provider>;
}

export const {Consumer} = UserContext;
